document.querySelectorAll('[data-rg-team-product]').forEach(root=>{
  const inputs=[...root.querySelectorAll('[data-variant]')];
  const count=root.querySelector('[data-total]');
  const estimate=root.querySelector('[data-estimate]');
  const error=root.querySelector('[data-error]');
  const minimum=Number(root.dataset.min)||10;
  const roster=window.RGPlayerRoster(root,inputs);
  const money=new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'});
  const field=name=>root.querySelector('[data-'+name+']').value.trim();
  function selected(){
    const rows=inputs.map(input=>({id:Number(input.dataset.variant),size:input.dataset.size,price:Number(input.dataset.price),quantity:Number(input.value)})).filter(row=>Number.isInteger(row.quantity)&&row.quantity>0);
    const total=rows.reduce((n,row)=>n+row.quantity,0);
    count.textContent=total+' '+(total===1?'set':'sets');
    estimate.textContent=total?'Selected kit total: '+money.format(rows.reduce((n,row)=>n+row.quantity*row.price,0)/100)+' AUD':'Select sizes to see your total.';
    if(total>=minimum)error.hidden=true;
    return {rows,total};
  }
  function valid(){
    if(inputs.some(input=>input.value!==''&&(!Number.isInteger(Number(input.value))||Number(input.value)<0||Number(input.value)>999))){error.textContent='Enter a whole number from 0 to 999 for each size.';error.hidden=false;return null}
    const choice=selected();
    if(choice.total<minimum){error.textContent='Please select at least '+minimum+' sets across your team.';error.hidden=false;inputs[0]?.focus();return null}
    return choice;
  }
  inputs.forEach(input=>input.addEventListener('input',selected));
  root.querySelector('[data-order-whatsapp]').addEventListener('click',()=>{
    const choice=valid();if(!choice)return;
    const sizes=choice.rows.map(row=>row.size+': '+row.quantity).join(', ');
    const message=['Hi RG Sports, I would like to discuss this custom team order.','Product: '+root.dataset.title,'Link: '+root.dataset.url,'Team: '+(field('team')||'To confirm'),'Sizes: '+sizes+' ('+choice.total+' sets)','Colours/design: '+(field('notes')||'To discuss'),'Players:',''+roster.lines().join('\n'),'Please help with the free design mock-up.'];
    window.open('https://wa.me/61405632724?text='+encodeURIComponent(message.join('\n')),'_blank','noopener');
  });
  const checkout=root.querySelector('[data-order-checkout]');
  checkout.addEventListener('click',async()=>{
    const choice=valid();if(!choice)return;
    checkout.disabled=true;checkout.textContent='Adding your team kits…';error.hidden=true;
    const properties={'Team or club':field('team')||'To confirm','Design notes':field('notes')||'To discuss','Artwork approval':'Required before production'};
    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:choice.rows.map(row=>({id:row.id,quantity:row.quantity,properties:{...properties,...roster.propertiesForSize(row.size)}}))})});
      if(!response.ok){const data=await response.json();throw new Error(data.description||data.message||'Unable to add these kits.')}
      window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
    }catch(e){error.textContent=e.message||'Could not start checkout. Please try again or message us on WhatsApp.';error.hidden=false;checkout.disabled=false;checkout.textContent='Buy securely through checkout →'}
  });
  selected();
});
